import { render } from "./LicenceBrowseItem.vue?vue&type=template&id=059efeba"
import script from "./LicenceBrowseItem.vue?vue&type=script&lang=js"
export * from "./LicenceBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script